/**
 * Class that contains the rendered question
 */
import { Typography } from "@mui/material";
import MultiChoiceQuestion from "../MultiChoiseQuestion";
import OpenQuestion from "../openQuestion";


const RenderedQuestion = ({
  currentQuestion,
  currentUserAnswer,
  onResponse,
}) => {

  // this function will reformat the question text, if it contains iframe transform the url to be correct
  const questionTextReformat = questionText => {
    let newText = questionText;
    if (questionText.includes("<iframe")) {
      newText = questionText
        .replace("?mode", "&mode")
        .replace("?text", "&text")
        .replace(
          `src="/Refrences`,
          `src=/api/questionnaire/get-html-file?html=./Refrences`
        )
        .replace(
          `src="./Refrences`,
          `src=/api/questionnaire/get-html-file?html=./Refrences`
        );
    }
    return newText;
  };

  return (
    <>
      <Typography variant="h5" component="h2" gutterBottom>
        שאלה {currentQuestion.questionIndex + 1}
      </Typography>
      {currentQuestion &&
        currentQuestion.options &&
        (currentQuestion.options.length > 1 ||
          (currentQuestion.options.length == 1 &&
            currentQuestion.options[0].text === "אני מתחייב")) && (
          <MultiChoiceQuestion
            id={currentQuestion.questionId}
            question_text={questionTextReformat(
              currentQuestion.questionText
            )}
            options={currentQuestion.options.map(option => ({
              id: option.id,
              text: questionTextReformat(option.text)
            }))}
            selectedOptionId={currentUserAnswer}
            onResponse={onResponse}
          />
        )}
      {currentQuestion &&
        currentQuestion.options &&
        currentQuestion.options.length <= 1 &&
        !(
          currentQuestion.options.length == 1 &&
          currentQuestion.options[0].text === "אני מתחייב"
        ) && (
          <OpenQuestion
            id={currentQuestion.questionId}
            question_text={currentQuestion.questionText}
            onResponse={onResponse}
            type={currentQuestion.options[0] ? currentQuestion.options[0].text : null}
            selectedResponse={currentUserAnswer}
          />
        )}
    </>
  );
};
export default RenderedQuestion;
